export default class Image {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(data) {
        Object.defineProperty(this, "alt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "src", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "thumb", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (!data)
            return;
        if ((data === null || data === void 0 ? void 0 : data.constructor) === String) {
            this.src = data;
            this.thumb = data;
            this.alt = data;
            return;
        }
        if (!this.src) {
            this.src = data.src || data.full_path || data.path;
        }
        if (!this.thumb) {
            this.thumb = data.thumb || data.thumb_path || this.src;
        }
        if (!this.alt) {
            this.alt = data.alt || '';
        }
    }
}
